export enum RegisterFlowTypesEnum {
    'SIMPLE' = 'SIMPLE',
    'REWARD' = 'REWARD'
}